<template>
  <el-container class="tariffs"> <!-- убрать если появится вкладка логов -->
    <main class="tab__container">
      <h2 class="page__title">
        Список тарифов
      </h2>
      <el-tabs>
        <el-tab-pane>
          <div class="tab">
            <el-footer class="tab__footer page__active_bar">
              <el-button
		v-if="$can('create', 'tariffs')"
                id="addTariff"
                class="page__active_button"
                type="primary"
                icon="el-icon-plus"
                @click="$router.push({ name: 'tariff:create' })"
              >
                Добавить
              </el-button>
            </el-footer>
            <div class="page_container">
              <el-table class="list" :data="customTariffs">
                <el-table-column prop="name" label="Название тарифа" />
                <el-table-column align="center" prop="price_per_day" label="Стоимость тарифа за 1 день в отчетном периоде">
                  <template slot-scope="scope">
                    <el-input
                      :ref="`price-input-${scope.$index}`"
                      :value="scope.row.price_per_day + ' ₽'"
                      size="small"
                      style="width: 140px"
                      readonly
                    >
                      <template v-if="$can('update', 'tariffs')" slot="append">
                        <el-button @click="onEdit(scope.row)">
                          <fa :icon="['fas', 'pencil-alt']" />
                        </el-button>
                      </template>
                    </el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="created_at" label="Дата начала действия тарифа" />
                <el-table-column prop="archive_depth" label="Квота хранения архива" />
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </main>

  </el-container>
</template>

<script>
import { faPencilAlt, faRubleSign, faSave, faUndo } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { ApiService } from "@/api";

library.add(faPencilAlt, faRubleSign, faSave, faUndo);

export default {
  name: "TariffsList",
  components: { fa },
  data() {
    return {
      tariffs: [],
    };
  },
  computed: {
    customTariffs() {
      return this.tariffs.map((tarrif) => {
        const oTariff = Object.assign({}, tarrif);

        // PRVK-627
        if (oTariff.archive_depth === -1) {
          oTariff.archive_depth = "-";
        }

        return oTariff;
      });
    },
  },
  created() {
    ApiService.tariffs.getList().then((tariffs) => {
      this.tariffs = tariffs;
    });
  },
  methods: {
    onEdit(tariff) {
      this.$prompt(`Стоимость тарифа за 1 день:`, `Тариф "${tariff.name}"`, {
        confirmButtonText: "Сохранить",
        cancelButtonText: "Отменить",
        inputType: "number",
        inputValidator: (value) => value > 0,
        inputValue: tariff.price_per_day,
        inputErrorMessage: "Некорректная стоимость",
      }).then(({ value }) => {
        this.save(tariff, value);
      });
    },
    save(tariff, price_per_day) {
      ApiService.tariffs
        .update(tariff.id_tariff, { price_per_day })
        .then((updatedTariff) => {
          const index = this.tariffs.findIndex((t) => t.id_tariff === tariff.id_tariff);

          this.tariffs[index].price_per_day = updatedTariff.price_per_day;
          this.tariffs[index].created_at = updatedTariff.created_at;

          this.$message({
            message: `Тариф "${tariff.name}" успешно обновлен`,
            type: "success",
          });
        })
        .catch((e) => {
          this.$message({
            message: e.response.data.error || "Неизвестная ошибка",
            type: "error",
          });
        });
    },
  },
};
</script>
